// extracted by mini-css-extract-plugin
module.exports = {"networkButton":"NetworkButton_networkButton__1MS_i"};